import React from 'react';
import { Outlet}  from 'react-router-dom';

const Cashout = () => {
  return (
    <div className='h-100'>
      <Outlet />
    </div>
  );
};

export default Cashout;
